import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Article} from "./article.model";

@Injectable({providedIn: 'root'})
export class ArticleService {
    constructor(private http: HttpClient) {
    }

    clone(id: number, cloneProducts: boolean): Observable<Article> {
        return this.http.get<Article>(
            `${environment.rootUrl}/article/clone/${id}/${cloneProducts}`
        );
    }

    encryptFilenames(articleNos: string[]): Observable<{ [articleNo: string]: string }> {
        return this.http.post<{ [articleNo: string]: string }>(
            `${environment.rootUrl}/article/encrypt-filenames`, articleNos
        );
    }
}
